import { useContext } from "react";
import { AuthContext } from "../contexts/AuthContext";

/**
 * Hook to access unified auth state
 * Supports both HMAC and JWT authentication via discriminated union
 */
export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (ctx === undefined) {
    throw new Error("useAuth must be used within AuthProvider");
  }
  return ctx;
};
